import axios from 'axios';


export function setAuth() {
    const token = sessionStorage.getItem('auth-token');
    if (token) {

        axios.defaults.headers.common['Authorization'] = token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
}